module.exports = __webpack_public_path__ + "img/ashtree-logo.6e5c7159.png";